import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { LmsService } from '../../_Lms/services/lms.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-branch-hierarchy-details',
  templateUrl: './branch-hierarchy-details.component.html',
  styleUrls: ['./branch-hierarchy-details.component.scss'],
  standalone: false
})
export class BranchHierarchyDetailsComponent implements OnInit {
  private data: any; showSpinner: boolean = false;
  branchList: any[] = [];
  isVertical: boolean = true;

  constructor(private _Route: Router, private dataSharingService: DataSharingService, public snackBar: MatSnackBar, private _LmsService: LmsService) {
    this.data = JSON.parse(sessionStorage.getItem('currentUser'));
  }
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next('Branch Hierarchy');
    this.Get_BranchHierarchyTree();
  }

  getNextLabel(level: string): string {
    const map: any = { Country: 'Zones', Zone: 'States', State: 'Regions', Region: 'Clusters', Cluster: 'Branches' };
    return map[level] || '';
  }

  getNextCount(node: any): number {
    const map: any = { Country: node.ZoneCount, Zone: node.StateCount, State: node.RegionCount, Region: node.ClusterCount, Cluster: node.BranchCount };
    return map[node.NodeLevel] || 0;
  }

  Get_BranchHierarchyTree() {
    this.showSpinner = true;
    this._LmsService.GetBranchHierarchyTree().subscribe((res: any) => {
      this.showSpinner = false;
      this.branchList = res.filter((obj: any) => obj.ParentNodeId == null);
      this.makeTree(res, this.branchList);
    })
  }

  makeTree(allData: any[], parentData: any[]) {
    for (let i = 0; i < parentData.length; i++) {
      let children = allData.filter((obj: any) => obj.ParentNodeId == parentData[i].NodeId);
      this.makeTree(allData, children);
      parentData[i].Children = children;
    }
  }
}
